import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { Box, Stack } from "@mui/material";

import { FearuredRedeemPartnerCard } from "./FearuredRedeemPartnerCard";
import { styles } from "./styles";
import { FearuredRedeemPartnerCarouselProps } from "./types";

export const FearuredRedeemPartnerCarousel: React.FC<FearuredRedeemPartnerCarouselProps> = ({ cards, isInformative }) => {
  if (!cards?.length) {
    return null;
  }

  return (
    <Stack px={{ xs: 3, md: 4, lg: 10 }}>
      <Box css={styles.container} maxWidth="100vw">
        <Swiper
          pagination={{
            clickable: true
          }}
          modules={[Pagination]}
          slidesPerView={1}
          spaceBetween="24px"
        >
          {cards.map((card, index) => (
            <SwiperSlide
              key={index}
              style={{
                height: "auto",
                minWidth: "100%"
              }}
            >
              <FearuredRedeemPartnerCard card={card} key={index} isInformative={isInformative} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Stack>
  );
};
